export const UNSET_INT = -1;
export const NEW_LINE = "\n";
